function addItemToCart(productId, quantity, selling_plan = null) {
  const body = selling_plan ? JSON.stringify({
    id: productId,
    quantity: quantity,
    selling_plan: selling_plan
  }) : JSON.stringify({
    id: productId,
    quantity: quantity
  });

//if drawer__inner-empty exists, remove it
  const drawerEmptyElement = document.querySelector('.drawer__inner-empty');
  if (drawerEmptyElement) {
      drawerEmptyElement.remove();
  }

  fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then(response => response.json())
    .then(cartData => {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'add-item', cartData: cartData });
      
        //if picker-wrapper form exists, remove it
        const pickerElement = document.getElementById('picker-wrapper');
        if (pickerElement) {
            pickerElement.classList.remove('active');
            pickerElement.innerHTML = '';
        }
      //if .drawer has class .is-empty, remove it
        const drawerElement = document.querySelector('.drawer');
        if (drawerElement.classList.contains('is-empty')) {
            drawerElement.classList.remove('is-empty');
        }

        //if CartDrawer-Checkout is disabled, remove disabled attribute
        const checkoutButton = document.getElementById('CartDrawer-Checkout');
        if (checkoutButton.hasAttribute('disabled')) {
            checkoutButton.removeAttribute('disabled');
        }
    })
    .catch(error => console.error('Failed to add item to cart:', error));
}

function closePicker() {
    const cartDrawerElement = document.querySelector('cart-drawer');
    if(!cartDrawerElement) return;
    cartDrawerElement.close();  // Make sure this method exists on your cart-drawer element  
}

function openCart(triggeredBy) {
  const cartDrawerElement = document.querySelector('cart-drawer');
  cartDrawerElement.open(triggeredBy);  // Make sure this method exists on your cart-drawer element

}
function openPicker(triggeredBy) {
    const pickerElement = document.getElementById('picker-wrapper');
    if(!pickerElement) return;
    pickerElement.classList.add('active');
    pickerElement.innerHTML = '<form class="active"></form>'; //add blank form.
    openCart(triggeredBy);
  
    // Always refresh cartDrawer contents
    fetch(routes.cart_url + '.js')
    .then(response => response.json())
    .then(cartData => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: cartData });
    })
    .catch(error => {
        console.error('Failed to load cart:', error);
        // Optionally handle an empty cart scenario
        // e.g., publish an empty cart update or show a "cart is empty" message in the UI
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: { items: [] } });
    });
    
  }
  